export function foneMask(value: string) {
    value = value.replace(/\D/g, '')

    if (value.length === 10) {
        value = value.replace(/(\d{2})(\d{4})(\d)/, '($1) $2-$3')
    }

    if (value.length === 11) {
        value = value.replace(/(\d{2})(\d{5})(\d)/, '($1) $2-$3')
    }

    return value
}

export function cnpjCpfMask(value: string) {
    value = value.replace(/\D/g, '')

    if (value.length === 11) {
        value = value.replace(/^(\d{3})(\d{3})(\d{3})(\d)/, '$1.$2.$3-$4')
    }
    if (value.length === 14) {
        value = value.replace(
            /^(\d{2})(\d{3})(\d{3})(\d{4})(\d)/,
            '$1.$2.$3/$4-$5'
        )
    }

    return value
}

export function cnpjCpfMaskHidden(valor: string) {
    const mask = cnpjCpfMask(valor)
    const array = mask.split('')
    array.splice(0, 3, '*', '*', '*')
    array.splice(-2, 2, '*', '*')
    array.splice(-4, 1, '*')
    return array.join('')
}

export function zipcodeMaks(value: string) {
    value = value.replace(/\D/g, '')
    value = value.replace(/^(\d{5})(\d)/, '$1-$2')
    return value
}

export function parseDate(date: string, toBrasil = false) {
    const dataLiquidacaoArray = date.split('-')
    if (toBrasil) {
        const dataLiquidacaoParsed = `${dataLiquidacaoArray[2]}/${dataLiquidacaoArray[1]}/${dataLiquidacaoArray[0]}`
        return dataLiquidacaoParsed
    }
    const dataLiquidacaoParsed = `${dataLiquidacaoArray[1]}/${dataLiquidacaoArray[2]}/${dataLiquidacaoArray[0]}`
    return dataLiquidacaoParsed
}
